const CryptoJS = require('crypto-js'); //引用AES源码js

const SECRETKEY = 'www.tuodielib.cn';

//加密方法
function AESEncrypt(word) {
  let aes = CryptoJS.AES.encrypt(CryptoJS.enc.Utf8.parse(word), CryptoJS.enc.Utf8.parse(SECRETKEY), {
    mode: CryptoJS.mode.ECB,
    padding: CryptoJS.pad.Pkcs7
  });
  return encodeURIComponent(aes.toString());
}

function AESDecrypted(encrypted) {
  let decrypted = CryptoJS.AES.decrypt(decodeURIComponent(encrypted), CryptoJS.enc.Utf8.parse(SECRETKEY), {
    mode: CryptoJS.mode.ECB,
    padding: CryptoJS.pad.Pkcs7
  });
  return CryptoJS.enc.Utf8.stringify(decrypted).toString();
}

export {
  AESEncrypt,
  AESDecrypted
}